import React from 'react';
import { Link } from 'react-router';

const LoginRequired = ({ location }) => {
  return (
    <div className="login-required">
      <h2>This project is double top secret.</h2>
      <p>Just kidding - all you need to do is log in and you'll be able to view the details.</p>
      <Link rel="nofollow" className="btn btn-primary" to={"/login?next=" + location.pathname}>
        Log in
      </Link>
    </div>);
}

export default LoginRequired;



// WEBPACK FOOTER //
// ./project/components/login_required.jsx